type Animation = "slideUp" | "slideDown" | "slideLeft" | "slideRight" | "slideExpandUp" | "expandUp" | "fadeIn" | "fadeOut" | "expandOpen" |
    "bigEntrance" | "hatch" | "bounce" | "pulse" | "floating" | "tossing" | "pullUp" | "pullDown" | "stretchLeft" | "stretchRight" | string;
type AttentionSeekers = "animate__bounce" | "animate__flash" | "animate__pulse" | "animate__rubberBand" | "animate__shake" | "animate__swing" | "animate__tada" | "animate__wobble" | "animate__jello" | "animate__heartBeat";
type BackEntrances = "animate__backInDown" | "animate__backInLeft" | "animate__backInRight" | "animate__backInUp";
type BackExits = "animate__backOutDown" | "animate__backOutLeft" | "animate__backOutRight" | "animate__backOutUp";
type BouncingEntrances = "animate__bounceIn" | "animate__bounceInDown" | "animate__bounceInLeft" | "animate__bounceInRight" | "animate__bounceInUp";
type BouncingExits = "animate__bounceOut" | "animate__bounceOutDown" | "animate__bounceOutLeft" | "animate__bounceOutRight" | "animate__bounceOutUp";
type FadingEntrances = "animate__fadeIn" | "animate__fadeInDown" | "animate__fadeInDownBig" | "animate__fadeInLeft" | "animate__fadeInLeftBig" | "animate__fadeInRight" | "animate__fadeInRightBig" | "animate__fadeInUp" | "animate__fadeInUpBig";
type FadingExits = "animate__fadeOut" | "animate__fadeOutDown" | "animate__fadeOutDownBig" | "animate__fadeOutLeft" | "animate__fadeOutLeftBig" | "animate__fadeOutRight" | "animate__fadeOutRightBig" | "animate__fadeOutUp" | "animate__fadeOutUpBig";
type Flippers = "animate__flip" | "animate__flipInX" | "animate__flipInY" | "animate__flipOutX" | "animate__flipOutY";
type Lightspeed = "animate__lightSpeedIn" | "animate__lightSpeedOut";
type RotatingEntrances = "animate__rotateIn" | "animate__rotateInDownLeft" | "animate__rotateInDownRight" | "animate__rotateInUpLeft" | "animate__rotateInUpRight";
type RotatingExits = "animate__rotateOut" | "animate__rotateOutDownLeft" | "animate__rotateOutDownRight" | "animate__rotateOutUpLeft" | "animate__rotateOutUpRight";
type Specials = "animate__hinge" | "animate__rollIn" | "animate__rollOut";
type ZoomEntrances = "animate__zoomIn" | "animate__zoomInDown" | "animate__zoomInLeft" | "animate__zoomInRight" | "animate__zoomInUp";
type ZoomExits = "animate__zoomOut" | "animate__zoomOutDown" | "animate__zoomOutLeft" | "animate__zoomOutRight" | "animate__zoomOutUp";
type SlidingEntrances = "animate__slideInDown" | "animate__slideInLeft" | "animate__slideInRight" | "animate__slideInUp";
type SlidingExits = "animate__slideOutDown" | "animate__slideOutLeft" | "animate__slideOutRight" | "animate__slideOutUp";

type AllAnimations = Animation | AttentionSeekers | BackEntrances | BackExits | BouncingEntrances | BouncingExits | FadingEntrances | FadingExits | Flippers | Lightspeed | RotatingEntrances | RotatingExits | Specials | ZoomEntrances | ZoomExits | SlidingEntrances | SlidingExits;

export const animateById: any = (id: string, animation: AllAnimations = "animate__fadeIn") => new Promise<void>((resolve, reject) => {
    const element: Element | null = document.getElementById(id);
    if (element) {
        element.classList.add(animation);
        element.addEventListener("animationend", () => {
            element.classList.remove(animation);
            resolve();
        });
    } else {
        console.error(`Error Animating: Element with id ${id} not found`);
        reject();
    }
});

export const deleteDynamicRowByKeyField: any = (tableId: string, keyField: string) => new Promise<void>((resolve, reject) => {
    const table: Element | null = document.getElementById(tableId);
    if (table) {
        const row: Element | null = table.querySelector(`.row-keyfield-${keyField}`);
        if (row) {
            row.classList.add("fadeOutDanger");
            row.addEventListener("animationend", () => {
                row.classList.remove("fadeOutDanger");
                resolve();
            });
        } else {
            reject("Error Deleting: Row not found");
        }
    } else {
        reject("Error Deleting: Table not found");
    }
});

export const deleteDynamicRowIndex: any = (tableId: string, index: number) => new Promise<void>((resolve, reject) => {
    const table: Element | null = document.getElementById(tableId);
    if (table) {
        const rows: any = table.querySelectorAll(`tr`);
        if (rows) {
            const row: Element | null = rows[index];
            if (row) {
                row.classList.add("fadeOutDanger");
                row.addEventListener("animationend", () => {
                    row.classList.remove("fadeOutDanger");
                    resolve();
                });
            }

        } else {
            reject("Error Deleting: Row not found");
        }
    } else {
        reject("Error Deleting: Table not found");
    }
});

export interface TableAnimationReturnType {
    success: boolean;
    message: string;
}

export const highlightTableRowById: any = (tableId: string, id: string, toggle: boolean = true, type: "elmblue" | "danger" = "elmblue") => new Promise<TableAnimationReturnType>((resolve, reject) => {
    const rowId: string = `#${id}`;
    const table: Element | null = document.getElementById(tableId);
    if (table) {
        const row: Element | null = table.querySelector(rowId);
        if (row) {
            if (toggle) {
                //r-18-lint-dj
                //eslint-disable-next-line
                row.classList.add("pulse-row-background" + "-" + type);
            } else {
                //r-18-lint-dj
                //eslint-disable-next-line
                row.classList.remove("pulse-row-background" + "-" + type);
            }
            resolve({ success: true, message: "Row Highlighted" });
        } else {
            resolve({ success: false, message: `Error Highlighting: Row not found -> ${rowId}` });
            // reject(`Error Highlighting: Row not found -> ${rowId}`);
        }
    } else {
        resolve({ success: true, message: `Error Highlighting: Table not found -> ${tableId}` })
        // reject(`Error Highlighting: Table not found -> ${tableId}` );
    }
});

export const deleteTableRowById: any = (tableId: string, rowId: string) => new Promise<TableAnimationReturnType>((resolve, reject) => {
    const table: Element | null = document.getElementById(tableId);
    if (table) {
        const row: Element | null = table.querySelector(`#${rowId}`);
        if (row) {
            row.classList.add("fadeOutDanger");
            row.addEventListener("animationend", () => {
                row.classList.remove("fadeOutDanger");
                resolve({ success: true, message: "" });
            });
        } else {
            resolve({ success: false, message: "Error Deleting: Row not found" });
            // reject("Error Deleting: Row not found");
        }
    } else {
        resolve({ success: false, message: "Error Deleting: Table not found" });
        // reject("Error Deleting: Table not found");
    }
});